import { setActiveProject } from "../../firebase/firebase_setup";
import { Box, Dialog, DialogTitle, List, ListItem } from "@mui/material";

function ChangeProjectDialog({userData, open, handleClose}) {

  const handleListItemClick = async(project) => {
    await setActiveProject(userData.active_organisation_id, project.id, userData);
    window.location.reload();
  }

  var projects = [];
  var activeProjectId = null;
  userData.organisations.forEach((organisation) => {
    if (organisation.id === userData.active_organisation_id) {
      projects = organisation.projects;
      activeProjectId = organisation.active_project_id;
    }
  })
  const filteredProjects = projects;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Change Project</DialogTitle>
      <List sx={{ pt: 0 }}>
        {filteredProjects.map(project => {
          return (
            <Box sx={{marginLeft: '10px'}}>
              <ListItem sx={{cursor: 'pointer'}} disableGutters key={project.id} onClick={() => {handleListItemClick(project)}}>
                {project.id}
              </ListItem>
            </Box>
          )
        })}
      </List>
    </Dialog>
  )
} 

export default ChangeProjectDialog;